import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import axios from './../../../constants/axios';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import classname from 'classnames';

class ExpenseHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         expenses: [],
         startDate: null,
         endDate: null,
      };
   }

   componentDidMount() {
      axios.get('expenses')
         .then((res) => {
            this.setState({
               expenses: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getInvoicesDateBetween = () => {
      const { startDate, endDate } = this.state;
      this.setState({
         expenses: [],
      });
      if (startDate && endDate) {
         axios.get(`expenses?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  expenses: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   render() {
      const { expenses } = this.state;
      return (
         <div className="ExpenseHome" >
            <h1 >Expense Home</h1 >
            <div >
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.startDate}
                  placeholderText="Select Start Date"
                  onChange={this.handleStartDateChange} />
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.endDate}
                  placeholderText="Select End Date"
                  onChange={this.handleEndDateChange} />
               <Button onClick={() => this.getInvoicesDateBetween()} >Get Invoices</Button >
            </div >
            <Table >
               <thead >
               <tr >
                  <th >#inv Id</th >
                  <th >Contact Name</th >
                  <th >Billed</th >
                  <th >Paid Amount</th >
                  <th >Due</th >
                  <th >Inv Created</th >
                  <th >##</th >
               </tr >
               </thead >
               <tbody >
               {expenses.map((expense) => (
                  <tr key={expense.id} className={classname({ 'due_invoice': expense.due !== 0 })} >
                     <td >{expense.id}</td >
                     <td >{expense.contact_name}</td >
                     <td >{expense.total_amount}</td >
                     <td >{expense.paid_amount}</td >
                     <td >{expense.due}</td >
                     <td >{expense.created_at}</td >
                     <td >
                        <Link to={`/expense/expenseInvoiceDetail/${expense.id}`} >Details</Link >
                        {expense.due !== 0 &&
                        <Link to={`/expense/expensePayBill/${expense.id}`} >Pay</Link >
                        }
                     </td >
                  </tr >
               ))}
               </tbody >
            </Table >
         </div >
      );
   }
}

ExpenseHome.propTypes = {};


export default ExpenseHome;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Expense/ExpenseHome.js
 **/